import React from 'react';

import { Col, IBasicStyledProps } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';

import { StyledProductSkeleton } from './styled';

export const ProductListSkeleton: ReactFCV<IBasicStyledProps> = (rest) => (
  <Col {...rest}>
    <StyledProductSkeleton />
    <StyledProductSkeleton />
  </Col>
);
